module.exports = __webpack_public_path__ + "img/c08_unitstartechwarelephantchampion_Normal_ua.dd9c545b.webp";